//#region [IMPORT]

import React, { createContext, useEffect, useState } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
 } from '@mui/material';

// === API ===
import { prokeyApi } from 'api/index';

//#endregion

//-----------------------------------------------------------------
export function ProcessList( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { onChange } = props;

  const theme = useTheme();

  const [ processes , setProcesses ] = useState( [] );
  const [ process   , setProcess   ] = useState( '' );

  //#endregion

  //#region [STYLES]

  // SX
  const _styles = {
    FORM: {
      backgroundColor : theme.palette.background.primary[theme.palette.mode],
    },
    ACTIVE: {
      height: '0.5rem',
    },
    INACTIVE: {
      color  : theme.palette.success.main,
      height : '0.5rem',
      width  : '0.5rem',
    },
    PROCESS_SELECT: {
      marginRight : '0.5rem' ,
      height      : '4rem'   ,
      width       : '20rem'  ,
      backgroundColor : theme.palette.background.primary[theme.palette.mode],
    }
  }

  // ATTRIBUTES
  const FORM = {
    sx      : _styles.FORM ,
    variant : 'filled'    ,
  }
  const PROCESS_LABEL = {
    htmlFor  : 'process_select' ,
    children : ['OCR Process']  ,
  }
  const PROCESS_SELECT = {
    id: 'process_select',
    value: process,
    onChange: (event) => {
      onChange(event.target.value);
      setProcess(event.target.value);
    },
    inputProps: {
      name: 'spName',
      id: 'process_select',
    },
    sx: _styles.PROCESS_SELECT
  }

  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    //-----------------------------------------------------------------
    async function getProcesses() {
      //-----------------------------------------------------------------
      try {
        const response = await prokeyApi.getOcrodProcesses();

        if( response.status !== 200 ) return console.warn(`Failed to retrieve process list; status ${response.status}`);

        const list = response.data.processList;
        if( !list ) return;

        setProcesses( list );

        if (process === '') 

        setProcess( list[0] );

        onChange( list[0] );

      } catch (error) {
        console.error(error);
      }
    }

    getProcesses();

  }, []);

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <FormControl { ...FORM } >
        <InputLabel {...PROCESS_LABEL}/>
        <Select { ...PROCESS_SELECT }>
          {displayProcess()}
        </Select>
      </FormControl>
    );
  };
  
  //-----------------------------------------------------------------
  function displayProcess() {
    //-----------------------------------------------------------------
    if ( !processes ) return null;

    return processes.map((option, index) => {
      return (
        <MenuItem key={index} value={option}>
          {option}
        </MenuItem>
      );
    });
  };



  //#endregion

  return display();
}
